import React from 'react'
import { useNavigate } from 'react-router-dom';
import 'react-slideshow-image/dist/styles.css';
import { Carousel } from "../Corousel/Carousel";

import data from "../../data/carouselData.json";

import imageOne from '../../resource/arama/individualPooja/1.png'
import imageFive from '../../resource/arama/individualPooja/4.png'
import imageSix from '../../resource/arama/individualPooja/5.png'
import imageThree from '../../resource/arama/individualPooja/2.png'
import TitleChnage from '../../Hook/TitleChnage'
import imageFour1 from '../../resource/arama/individualPooja/6.png'

import image1 from '../../resource/arama/annual-ceramony/Sannaspathraya.jpg'


const SelectDay = () => {
    TitleChnage("Individual Pooja")
     const navigate = useNavigate();
            
                const handleClick = (event) => {
            
                    const pathMap = {
                        aramaPoojaRequest : '/aramaPoojaRequest',
                    }
                
                    const path = event.currentTarget.id;
                    const targetPath = pathMap[path]
                
                    if (targetPath){
                      navigate(targetPath)
                    }
                  }

  return (
    <div className="indivdualpooja-page inside-pages">
    <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
    </div>

    <h1 className='font-main p-4 mt-4'>Select your own</h1>
    <h1 className='font-main p-4 mt-4'>Arama Pooja day</h1>


    <p className="mt-6 h4 p-4">Participating in the Arama Pooja offers a unique and meaningful opportunity to make a lasting contribution to the Buddhist community. While the common ceremony is held annually at the monastery, you are invited to select your own personal Arama Pooja day to commemorate a special occasion. This could include events such as birthdays, anniversaries, or the desire to share merits with living and departed relatives, or simply for the joy of making a contribution.</p>
    <p className="mt-5 h4 p-4">To arrange your personal Arama Pooja day, please coordinate witht the monastery in advance to ensure the availablity of the Sangha to receive hte sannaspathrea (Certificate of Gratitude). The ceremony can take place at the monastery, or you may choose to invite the sangha to your residence for event.</p>
    
    <h1 className='font-second p-4 mt-6'>Support the Bhaddeka Vihari Monastery and Meditation Centre</h1>
    
    <p className="mt-5 h4 p-4">You are cordially invited to join this noble endeavor by supporting the Bhaddeka Vihari Monastery and Meditaion Centre in repaying its existing $700,000 bank loan. Established in 2017, the monastery purchased a $2 million property. Despite the collective efforts of the Buddhist community, the funds raised were insufficient to cover the total cost, resulting in the need for a $1.4 million bank loan.</p>
    <p className="mt-5 h4 p-4">As part of the Arama Pooja , devotees have the opportunity to purchase a $500 land plot and offer the "Certificate of Gratitude" -- "Sannaspathra" - to the Arama. This contribution plays a crucial role in supporting the monastery and its ongoing efforts</p>


    <div className="calander-box mt-6 p-4 align-item-center text-center">
        <div className="img1">
        <img src={image1} style={{ width: "100%" }} />
        </div>
        <div className="img2">
        <h1 className='font-second p-4 mt-6'>Join the Virtuous Cause</h1>
    
        <p className="mt-5 h4 p-4">Your contribution to this meritorious cause is deeply appreciated. By securing one of the remaining 1400 sannaspathra, you help ensure the creation of a lasting refuge for spiritual growth and development. This sacred space with serve as a sanctuary for mindfulness, wisdom, and peace for generations to come.</p> 
        <p className="mt-5 h4 p-4">Together, let us nurture this sacred space, contributing to a flourishing environment where the Dhamma can be shared, practiced and passed on to future generations. </p>
        <p className="mt-5 h4 p-4">Your support is invaluable, and we sincerely thank you for your praticipation in this meaningful and virtuous act.</p>
        
        </div>
    </div>
    <div className=" mt-6 p-4">
          <Carousel data={data.selectDay} />
        </div>

   

  <div className='btn-group-flex mt-6'>
        <img src={imageFive} alt="Right Top Image" width={300} />
        <img src={imageSix} alt="Right Top Image" width={300} />
    </div>

    <div className="p-4 mt-6 text-center">
    <div className="mt-6 calander-box align-item-center">
            <div className="c-details text-left">
                <h2 className='intro-text '>Futher More Details : </h2>
                <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                <p className="font-p">Mr Gamini : 0422 069 359</p>
                <p className="font-p">WhatsApp : 0422 069 359</p>
                <p className="font-p">E-mail : info@bvp.org.au</p>
            </div>


            <div className="d-button">
                    <img src={imageFour1} alt="Right Top Image" className="right-image curser-pointer" width={300} id='aramaPoojaRequest' onClick={handleClick} />
                    </div>
        </div>
        </div>



        <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image"  width={600} />
    </div>

</div>
  )
}

export default SelectDay